import React, { useState } from "react";
import "./ResetPassword.css";
import api from '../api';

const ResetPassword = () => {

  const userid = localStorage.getItem('userid');
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const hasMinLength = password.length >= 6;
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const changePassword = async () => {

   let newPassword;

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    newPassword = password;
    try {
     const res =  await api.post(`/auth/change-password/${JSON.parse(userid)}`, { newPassword });
      if(res.status === 200){
        alert("Password changed successfully");
      }
      else {
        alert("Failed to change password");
      }
    } catch (error) {
      console.error(error);
      alert("Error changing password");
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-card">

        <h2>Set new password</h2>
        <p className="subtitle">
          Your new password must be different to previously used passwords.
        </p>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••"
          />
        </div>

        <div className="form-group">
          <label>Confirm password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="••••••••"
          />
        </div>

        <div className="rules">
          <div className="rule">
            <span className={`check ${hasMinLength ? "active" : ""}`}>✓</span>
            Must be at least 6 characters
          </div>
          <div className="rule">
            <span className={`check ${hasSpecialChar ? "active" : ""}`}>✓</span>
            Must contain one special character
          </div>
        </div>

        <button onClick={changePassword} className="reset-btn">Reset password</button>
      </div>
    </div>
  );
};

export default ResetPassword;
